<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
    >
      <template v-slot:showItem="{ row }">
        <el-row :gutter="10">
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              扣款项目：
              {{ row.v_deductionType }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              费用金额：
              {{ row.currencyAmount }}
            </span>
          </el-col>

          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              费用客户：
              {{ row.custName }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              相关订单：
              {{ row.custOrderNo }}
            </span>
          </el-col>

          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              供应商：
              {{ row.scmName }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              供应商扣款金额：
              {{ row.scmCurrencyAmount }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 10 }"
          >
            <span>
              分摊部门：
              {{ row.orgDepFullName }}
            </span>
          </el-col>
        </el-row>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
}
</script>
